/**
 * Service/Ed (Edaas) Controller
 *
 * Displays information about Edaas orders
 */

// the constructor for this object
function ServiceEdController() { }

// the object
ServiceEdController.prototype = {
    constructor: ServiceEdController,

    // the base order id
    baseOrderId: false,

    // store the license client count chart object here
    licenseCountChart: false,

    // store the license protected stats chart object here
    // licenseCountChart: false,

    // this contains the pagination object for license clients
    licensePagination: false,

    // the number of order per page
    perPage: 10,

    // the last data submitted to the API, used to prevent multiple api requests
    lastLicenseSubmittedData: {},

    // if this EDR/MDR has license data or management
    hasLicense: false,

    // initialize the controller
    init: function()
    {
        // the user must be logged in to access this page
        PortalMain.authRedirect();

        // register the route variables used by this controller
        this._registerRouteVariables();

        // set up the pagination
        this._setupPagination();

        // register charts
        this._registerCharts();

        PortalHelper.debugMessage('Service EDR/MDR Initialized');
    },

    // run the controller
    run: function()
    {
        // register the pagination events
        this.licensePagination.init();

        // get and populate the order
        this._getOrder();

        // get/populate the EDR/MDR specific order info
        this._getEdOrder();

        // register the events used by this controller
        this._registerEvents();

        PortalHelper.debugMessage('Service EDR/MDR Controller Ran');
    },

    // get the route variables and include them in the controller
    _registerRouteVariables: function()
    {
        var segments = PortalMain.getRouteSegments();

        // set the base order id
        if (segments.length == 1) {
            this.baseOrderId = segments[0];
        } else {
            // the uri is missing important pieces
            PortalHelper.sendToDashboard();
        }
    },

    // create the pagination object
    _setupPagination: function()
    {
        var licensePagination = new PortalPagination();
        licensePagination.urlParamKeys = {
            page: 'license-page',
            sort: 'license-sort',
            order: 'license-order',
            search: 'license-search',
        };
        licensePagination.perPage = this.perPage;
        licensePagination.paginationSelector = '#license-count-pagination';
        licensePagination.contentSelector = '#license-count-table';
        licensePagination.searchSelector = '#license-count-search';
        licensePagination.searchColumn = 'search_all';
        licensePagination.eventCallback = PortalMain.ServiceEdController._getEdOrder;
        PortalMain.ServiceEdController.licensePagination = licensePagination;

    },

    // register the javascript events
    _registerEvents:  function()
    {
        // bind to any of the dropdown links
        PortalHelper.hideDropdownOnClick('#range-selection-dropdown');
        $('#range-selection-dropdown ul li a').on('click', function(){
            PortalMain.ServiceEdController._updateChartRange(
                this.dataset.timelineRangeSeconds
            );

            PortalMain.ServiceEdController._updateSelectedRange(this);
        });
    },

    // register the chart
    _registerCharts: function()
    {
        // new chart for license client count history
        var licenseCountChart = new PortalChart;
        licenseCountChart.elementId = 'ed-licenses-chart';
        licenseCountChart.type = 'line';
        licenseCountChart.dataFormat = 'number';
        licenseCountChart.columns = [];
        this.licenseCountChart = licenseCountChart;

    },

    // get the orders from the api
    _getOrder: function()
    {
        PortalMain.ServiceIndexController = new ServiceIndexController;
        PortalMain.ServiceIndexController.baseOrderId = this.baseOrderId;
        PortalMain.ServiceIndexController._getOrder();
    },

    // get EDR/MDR specific order info (usage information)
    _getEdOrder: function()
    {
        var edOrderRequest = new PortalRequest;
        edOrderRequest.errorElement = '.order-fail';
        edOrderRequest.makeRequest(
            '/orders-ed/get-order-ed',
            {
                baseOrderId: this.baseOrderId,
            },
            function(data) {

                // get count of records to determine whether to display or not
                PortalMain.ServiceEdController._populateHasLicenses(data);

                // fill in the stats section
                PortalMain.ServiceEdController._populateEdOrderStats(data);

                // get the orders stats
                PortalMain.ServiceEdController._getEdStats();

            },
            function() {
                // no licenses order found, so hide the content
                $('#ed-content').addClass('hidden');
            }
        )
    },

    // store the EDR/MDR image or license components
    _populateHasLicenses: function(edInfo)
    {
        this.hasLicenses = edInfo.hasLicenses;
    },

    // redraw the chart to fill the now visible space
    _chartsTabClickCallback: function(tabTarget)
    {
        PortalMain.ServiceEdController.licenseCountChart.draw();
    },

    // populate document with usage information
    _populateEdOrderStats: function(edInfo)
    {
        if (!edInfo.hasLicenses) {
            $('#licenses-container').remove();
        }

        // show the active licenses stats
        if (edInfo.hasLicenses) {
            // set the Active Licenses count
            var activeLicenses = edInfo.active_licenses
            $('#ed-active-licenses').text(activeLicenses);

            // set the license rate
            var licenseRate = edInfo.licenses_rate;
            licenseRate = PortalHelper.numberToDollars(licenseRate, 2, true);
            $('#ed-rate-per').text(licenseRate);

            // set the total available licenses
            var licensesTotal = edInfo.active_licenses_hw;
            $('#ed-total-licenses').text(licensesTotal);

            // set the date
            var date = PortalHelper.formatDate(edInfo.last_run_date);
            $('#ed-stats .date').text(date);

            PortalHelper.loadingOverlay('#ed-stats', false);
        } else {
            $('.ed-stats').remove();
        }


    },

    // retrieves the timeline EDR/MDR stats
    _getEdStats: function(startDate, endDate)
    {
        // defaulting to 1 week range if a start or end date not passed
        if(!(startDate instanceof Date) || !(endDate instanceof Date)) {
            var startDate = new Date();
            var endDate = new Date();

            startDate.setMonth(
                startDate.getMonth() - 1
            );
        }

        var edStatsRequest = new PortalRequest;
        edStatsRequest.makeRequest(
            '/orders-ed/get-ed-stats',
            {
                baseOrderId: this.baseOrderId,
                // Date() strikes again. Dividing by 1000 here to get seconds instead of ms
                startDate: startDate.getTime() / 1000|0,
                endDate: endDate.getTime() / 1000|0,
            },
            function(data) {
                PortalMain.ServiceEdController._populateLicenseCountChart(data.license, startDate, endDate);
            }
        );
    },

    // sets up the protected graph, populating columns and data
    _populateLicenseCountChart: function(chartData, startDate, endDate)
    {
        if (chartData.length != 1) {
            // keep only the specified columns for the chart
             chartData = PortalHelper.chartGetColumns(chartData, [
                'Time',
                'Licenses Actively Used',
                'MTD Peak Licenses'
            ]);
            this.licenseCountChart.minDate = startDate;
            this.licenseCountChart.maxDate = endDate;
            // resetting columns first
            this.licenseCountChart.columns = [];

            this.licenseCountChart.columns[0] = ['date', chartData[0][0]];
            this.licenseCountChart.columns[1] = ['number', chartData[0][1]];
            this.licenseCountChart.columns[2] = ['number', chartData[0][2]];

            // If the only thing that is in the array is the Column names then there shouldn't be any data to show
            if(chartData.length == 1) {
                $('#ed-licenses-chart').text("No data available for this period.");
            } else {
                this.licenseCountChart.data = chartData;
                this.licenseCountChart.draw();
            }
            PortalHelper.loadingOverlay('#ed-stats', false);
            PortalHelper.loadingOverlay('#ed-licenses-chart', false);
        }
    },

    // changes what date range is displayed
    _updateChartRange: function(dateRangeSeconds)
    {
        PortalHelper.loadingOverlay('#ed-licenses-chart', true);
        var endDate = new Date();
        var startDate = new Date(
            endDate.getTime()
            - (dateRangeSeconds * 1000)
        );

        this._getEdStats(startDate, endDate);
    },

    // adds interactivity to the dropdown range selection
    _updateSelectedRange: function(element)
    {
        var selectedElementText = $(element).text();
        $('.selection-text').text(selectedElementText);
    },


}